exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card__delete[data-v-3eb7178e]{width:100%;height:100%;background:#fff;-webkit-box-shadow:0 3px 4px rgba(30,18,13,.1);box-shadow:0 3px 4px rgba(30,18,13,.1);border-radius:6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3eb7178e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/dashboard-v5/delete-account/components/card-delete.vue
// module id = Nvlx
// module chunks = 0